(function () {
  function initBlurUp() {
    document.querySelectorAll('.bu-has-placeholder').forEach(function (container) {
      var img = container.querySelector('.bu-img');
      if (!img) return;

      function markLoaded() {
        container.classList.add('is-loaded');
      }

      if (img.complete && img.naturalWidth > 0) {
        markLoaded();
      } else {
        img.addEventListener('load', markLoaded, { once: true });
        img.addEventListener('error', markLoaded, { once: true });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBlurUp);
  } else {
    initBlurUp();
  }
})();
